import { OnInit } from '@angular/core';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { DomSanitizer } from '@angular/platform-browser';
import { PublishService } from '../publish.service';
import { Store } from '@ngxs/store';
import { PublishState } from '../state/publish.state';
import { WidgetOptions } from '../models/widget-options.model';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
var EmbedSrcDirective = /** @class */ (function () {
    function EmbedSrcDirective(store, publishService, sanitizer) {
        this.store = store;
        this.publishService = publishService;
        this.sanitizer = sanitizer;
    }
    Object.defineProperty(EmbedSrcDirective.prototype, "model", {
        set: function (bookmark) {
            var widgetURL = this.store.selectSnapshot(PublishState.getWidgetURL);
            var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
            // build URL
            var url = this.publishService.getWidgetURL(bookmark, widgetURL, this.params, null, null, lang);
            this.src = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        },
        enumerable: true,
        configurable: true
    });
    EmbedSrcDirective.prototype.ngOnInit = function () {
    };
    return EmbedSrcDirective;
}());
export { EmbedSrcDirective };
